<template>
  <div class="Home" :style="{ 'width': _isMobile() ? '100%' : '1200px', 'margin': _isMobile() ? '-28px auto' : '0 auto' }">
    <div class="mainContent" :style="{borderRadius:_isMobile() ? '28px 28px 0 0' : 'none'}">
      <div class="header">
        <template v-if="_isMobile()">
          首页<i class="iconfont">&#xe63c;</i>
          <img src="../assets/image/JXW.png" class="jxwLogo" alt="">
        </template>
      </div>
      <a-row type="flex" justify="space-between" style="width: 90%;margin: 0 auto;">
        <a-col v-for="item, index in menuList" :key="index" :xs="11" :sm="11" :md="7" :lg="7" :xl="7">
          <div class="menuList" @click="toPageFn(item)" :style="{background:item.background}">
            <div class="left">
              <p class="menuName">{{ item.menuName }}</p>
              <p class="viceMenuName">{{ item.viceMenuName }}</p>
            </div>
            <div class="right">
              <img :src="item.imgUrl" style="width:41px;height: 44px;" alt="">
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import { mixinDevice } from "@/utils/mixin.js";
export default {
  name: 'Home',
  components: {  },
  mixins: [mixinDevice],
  data() {
    return {
      menuList: [
        {
          menuName: '普测练习',
          viceMenuName: '在线学习>',
          url: '/course/courseChoose?type=ZXXX',
          imgUrl: require('../assets/image/PCLX.png'),
          background:'#75B5F5'
        }, {
          menuName: '单招练习',
          viceMenuName: '在线练习>',
          url: '/course/courseChoose?type=ZXLX',
          imgUrl: require('../assets/image/DZLX.png'),
          background:'#FFAEAD'
        }, {
          menuName: '在线考试',
          viceMenuName: '在线考试 >',
          url: '/course/workBookList?type=ZXKS&status=0',
          imgUrl: require('../assets/image/ZXKS.png'),
          background:'#9EC0F8'
        }, {
          menuName: '班级作业',
          viceMenuName: '在线查看 >',
          url: '/course/workBookList?type=BJZY&status=2',
          imgUrl: require('../assets/image/BJZY.png'),
          background:'#F8DAB1'
        }, {
          menuName: '学生管理',
          viceMenuName: '在线管理 >',
          url: '',
          imgUrl: require('../assets/image/XSGL.png'),
          background:'#C1E3F6'
        }, {
          menuName: '心理健康',
          viceMenuName: '在线辅导 >',
          url: '/course/psychology',
          imgUrl: require('../assets/image/XLJK.png'),
          background:'#FCE9B7'
        },
      ]
    }
  },
  created() { },
  mounted() { },
  methods: {
    toPageFn(row) {
      this.$router.push({ path: row.url,query:{name:row.menuName} });
    }
  }
}
</script>
<style lang='scss' scoped>
.Home {
  width: 100%;
  margin:  -28px auto;

  .mainContent {
    width: 100%;
    background: #fff;
    .header{
      width: 100%;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 17px;
      color: #333;
      position: relative;
      .jxwLogo{
        width: 67px;
        height: 70px;
        position: absolute;
        top: -31px;
        right: 13px;
        z-index: 9;
      }
    }
  }

  .menuList {
    width: 100%;
    height: 86px;
    padding: 0 14px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 22px;
    cursor: pointer;

    .menuName {
      font-size: 19px;
      color: #fff;
      font-weight: normal;
    }

    .viceMenuName {
      font-size: 12px;
      color: #000;
      opacity: 0.5;
    }
  }
}
</style>
